/*
  One-up / two-up switch for the collection grid on phones.

  A strap photographed end-on is a tall, narrow thing. Two to a row it is thumbnail-sized and the
  stitching — the reason someone is on this page — is a few pixels of thread; one to a row it is
  worth looking at but the customer scrolls past four products to see six. Neither is right for
  everyone, so the choice is theirs, and it is remembered.

  Desktop is untouched: the grid there is already wide enough for the question not to arise.
*/
if (!customElements.get('collection-layout-toggle')) {
  class CollectionLayoutToggle extends HTMLElement {
    static STORAGE_KEY = 'xilugs:collection-columns';

    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      if (!this.grid) return;

      this.buttons = Array.from(this.querySelectorAll('[data-columns]'));
      this.apply(this.stored || this.currentFromGrid);

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-columns]');
        if (!button) return;
        this.apply(button.dataset.columns);
        try {
          localStorage.setItem(CollectionLayoutToggle.STORAGE_KEY, button.dataset.columns);
        } catch (e) {
          /* Private browsing refuses localStorage. The switch still works for this page. */
        }
      });

      /* Filtering and sorting replace the grid wholesale, taking the class with it. */
      document.addEventListener('shopify:section:load', () => this.restore());
      window.addEventListener('popstate', () => this.restore());
    }

    get stored() {
      try {
        return localStorage.getItem(CollectionLayoutToggle.STORAGE_KEY);
      } catch (e) {
        return null;
      }
    }

    get currentFromGrid() {
      return this.grid.classList.contains('grid--1-col-tablet-down') ? '1' : '2';
    }

    restore() {
      this.grid = document.getElementById('product-grid');
      if (this.grid) this.apply(this.stored || this.currentFromGrid);
    }

    apply(columns) {
      const value = columns === '1' ? '1' : '2';
      this.grid.classList.toggle('grid--1-col-tablet-down', value === '1');
      this.grid.classList.toggle('grid--2-col-tablet-down', value === '2');
      this.buttons.forEach((button) => {
        const active = button.dataset.columns === value;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('collection-layout-toggle', CollectionLayoutToggle);
}
